
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/privacy",
      function () {
        return require("private-next-pages/services/privacy.tsx");
      }
    ]);
  